import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AccountHeader = ({ backLink }) => {
  const { t } = useTranslation();
  return (
    <div className='u-margin-top--base u-margin-bottom--large'>
      <Link className='o-sp-button o-sp-button--back' to={backLink}>
        <i className='sp-icon-arrow-left'></i>&nbsp;{t('account.backToAllAdults')}
      </Link>
    </div>
  );
}

AccountHeader.propTypes = {
  backLink: PropTypes.object.isRequired,
}

export default AccountHeader;
